import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/images/graph3.png'
import _imports_1 from '../assets/images/graph4.png'


const _hoisted_1 = {
  key: 0,
  id: "superset-dashboard"
}
const _hoisted_2 = {
  key: 1,
  class: "row"
}
const _hoisted_3 = { class: "bg-white col-lg-12 col-md-12 col-sm-12 col-xl-12 default-border-radius q-layout-padding" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = {
  style: {"position":"relative"},
  class: "mb-2"
}
const _hoisted_7 = {
  class: "position-absolute w-75",
  style: {"top":"50%","left":"0px","transform":"translateY(-50%)","margin-left":"2rem","color":"white"}
}
const _hoisted_8 = { class: "h5 font-weight-normal" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "imageGraph",
  alt: "Graph illustration"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_1,
        class: "imageGraph",
        alt: "Graph illustration"
      })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "q-page q-layout-padding items-start pt-0" }, {
    default: _withCtx(() => [
      (!_ctx.homeImage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h1", null, _toDisplayString(_ctx.$t("main.title")), 1),
                      _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t("main.subtitle")), 1)
                    ]),
                    _hoisted_9
                  ])
                ])
              ]),
              _hoisted_10
            ])
          ]))
    ]),
    _: 1
  }))
}